import { ENDPOINTS } from 'utils/api/callApi'
import { keymirror } from 'utils/keymirror'

export const BIDS_COUNT_ACTION_TYPES = keymirror({
  BIDS_COUNT_REQUEST: null,
  BIDS_COUNT_SUCCESS: null,
  BIDS_COUNT_FAILURE: null,
})

export const BIDS_ACTION_TYPES = keymirror({
  BIDS_REQUEST: null,
  BIDS_SUCCESS: null,
  BIDS_FAILURE: null,
})

export const SUBMIT_BID_ACTION_TYPES = keymirror({
  SUBMIT_BID_REQUEST: null,
  SUBMIT_BID_SUCCESS: null,
  SUBMIT_BID_FAILURE: null,
})

export const getBidsCount = (ids = []) => ({
  payload: {
    callApi: true,
    requestData: {
      endpoint: ENDPOINTS.bids,
      group: 'grouped_count',
      params: { shipment_id: ids },
    },
    actionTypes: Object.keys(BIDS_COUNT_ACTION_TYPES),
  },
})

export const getBids = id => ({
  payload: {
    callApi: true,
    requestData: {
      endpoint: ENDPOINTS.bids,
      params: {
        sortOrder: 'desc',
        perPage: 20,
        filters: {
          shipmentId: id,
          includes: ['carrier_application', 'created_by', 'notes', 'similar'],
          source: ['marketplace', 'manual', 'covered', 'fleet_planner', 'mobile'],
        },
      },
    },
    actionTypes: Object.keys(BIDS_ACTION_TYPES),
  },
})

export const submitBid = ({ formData = {}, shipmentId, existingCarrier, carrierUpdates = {} }) => {
  const finalMc = carrierUpdates.mcNumber ? carrierUpdates.mcNumber : existingCarrier.mcNumber
  const finalDot = carrierUpdates.dotNumber ? carrierUpdates.dotNumber : existingCarrier.dotNumber
  const dispatcher = Number(formData.dispatcherId) ? 'carrierContactUserId' : 'carrierContactName'
  const carrierContactName = dispatcher === 'carrierContactUserId' && formData.dispatcherName

  const body = {
    ...formData,
    carrier_application_mc_number: finalMc,
    carrier_application_dot_number: finalDot,
    carrierContactName,
    [dispatcher]: formData.dispatcherId,
    shipmentId,
    direction: 'outbound',
    source: 'manual',
  }
  delete body.carrier

  return {
    payload: {
      callApi: true,
      requestData: {
        endpoint: ENDPOINTS.bids,
        method: 'POST',
        body,
      },
      actionTypes: Object.keys(SUBMIT_BID_ACTION_TYPES),
    },
  }
}
